// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_WAkLX {
  width: 100%;
  min-width: 200px;
  width: 200px;
  max-width: 200px;
  background: var(--f5-background);
  height: calc(100vh - 50px);
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  left: 0;
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 80vw;  
}
@media (width<= 768px) {
  .container_WAkLX {
    overflow-y: inherit;
    position: absolute;
    max-width: 100vw;
    width: 100vw !important;
  }
}

.asideBar_Fdam_ {
  height: calc(100vh - 50px);
  box-sizing: border-box;
  top: 0;
  z-index: 4;
  transition: left 0.3s ease;
  -webkit-transition: left 0.3s ease;
  -moz-transition: left 0.3s ease;
  -ms-transition: left 0.3s ease;
  -o-transition: left 0.3s ease;
  position: initial;

  left: 0;  
}
.mobileMenu_DmXUA {
  position: absolute;
  width: 100vw;
  z-index: 999999;
}

.container_WAkLX::-webkit-scrollbar {
  display: none;
}

.searchContainer_hoqds {
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.filesContainer_Si__B {
  display: flex;
  flex-direction: column;
  padding: 4px;
  box-sizing: border-box;
  height: calc(100vh - 78px);
  justify-content: space-between;
  .fileListt_b3FJ_ {
    position: relative;
    display: flex !important;
    flex-direction: column !important;
  }
}

.fileExplorerGetPlusContainer_NqGOc {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  height: 15%;
}

.moreGreen__xJWV {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  cursor: pointer;
  background: var(--white-background);
  width: 40px;
  height: 40px;
  border: 2px solid var(--ca-border);
  border-radius: 999px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  position: relative;
}
.moreGreen__xJWV svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); 
  width: 20px; 
  height: 20px; 
}
@media (width <= 768px) {
  .filesContainer_Si__B {
    flex-direction: column-reverse;
  }
}
.searchContainerL_hvS1d {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  cursor: pointer;

  img {
    transition: filter 0.1s ease;
    -webkit-transition: filter 0.1s ease;
    -moz-transition: filter 0.1s ease;
    -ms-transition: filter 0.1s ease;
    -o-transition: filter 0.1s ease;
  }
}
.searchContainerIcon_e3t9V {
  background-color: var(--ececf1-background);
  padding: 4px;
  border-radius: 4px;
  height: 10px;
  width: 10px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  cursor: pointer;
}



.searchInputWrapper_sqz6O {
  display: flex;
  align-items: center;
  background: var(--white-background);
  height: 36px;
  min-height: 36px;
  border: 1px solid var(--d9d9e3-border);
  border-radius: 8px;
  padding: 0px 9px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  width: 100%;
}
.searchIconsWrappers_VAOS4 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}
.loaderContainer_NIcBB {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
    height: 100%;
  background: radial-gradient(circle, var(--f5-background) 0%, rgba(245, 245, 245, 0.8) 30%, rgba(245, 245, 245, 0.4) 60%, transparent 100%);
    position:absolute;
}
.bottomLoaderContainer_QFHHr {
  position:absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, var(--f5-background) 0%, rgba(245, 245, 245, .8) 80%, rgba(245, 245, 245, 0.4) 90%, transparent 100%);
}
.searchIcon_CtmiT {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--_6-color);
}

.searchInput_zkxPa {
  flex: 1 1;
  padding: 8px;
  border: none;
  background: transparent;
  font-size: 14px;
  outline: none;
}

.searchInput_zkxPa::placeholder {
  color: var(--_6-color);
}

.menuIcon_HVJJj {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 24px;
  border: none;
  background: transparent;
  color: var(--_6-color);
  cursor: pointer;
  padding: 0;
  background-color: var(--_233f39-background);
  height: 100%;
  border-radius: 0 10px 10px 0;
  -webkit-border-radius: 0 10px 10px 0;
  -moz-border-radius: 0 10px 10px 0;
  -ms-border-radius: 0 10px 10px 0;
  -o-border-radius: 0 10px 10px 0;
}

.menuIcon_HVJJj:hover {
  color: var(--_3-color);
}



.folderHeader_K3DzI {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--_3-color);
}

.folderItem_iXVDX,
.fileItem_mSXrc {
  padding: 0px 6px;
  height: 34px;
  min-height: 34px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  border-radius: 8px;
  transition: background-color 0.2s ease-in-out;
}

.itemInner_alHLw {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 100%;
  padding: 0px;
  img {
    width: 15px;
        height: 18px;
  }
  input{
    outline: none;
    border: 1px solid var(--ececf1-border);
    background-color: var(--white-background);
    padding: 4px;

  }
}

.folderItem_iXVDX:hover,
.fileItem_mSXrc:hover {
  background-color: var(--f5f5f9-background);
}

.itemText_ClVHr {
  font-size: 12px;
  color: var(--_3-color);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
}

.fileListt_b3FJ_ {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  background: linear-gradient(0deg, var(--e9e9e96d-background) 21%, var(--f5-background) 100%);
  flex: 2 1;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.moreButton_q9u8C {
  position: relative;
  display: none;
  border: none;
  background: none;
  padding: 4px;
  cursor: pointer;
  opacity: 0;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease-in-out;
  margin-left: auto;
  margin-right: 5px;
}

.fileItem_mSXrc:hover .moreButton_q9u8C {
  opacity: 0.7;
  display: flex;
}

/* .moreButton:hover {
  opacity: 1 !important;
  background: var(--ea-background);
  border-radius: 4px;
} */

.optionsPopup_NRs9Y {
  position: fixed;
  background: var(--white-background);
  border-radius: 8px;
  box-shadow: 0 2px 10px var(--_0000001a-shadow);
  width: 115px;
  z-index: 9999;
  padding: 4px;

}
.optionsPopup_NRs9Y {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;
}

.optionsPopup_NRs9Y.visible__GGP7 {
  opacity: 1;
  pointer-events: auto;
}


.optionItem_q6sB1 {
  width: 100%;
  padding: 8px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: var(--_3-color);
  border-radius: 4px;
  transition: background-color 0.2s ease-in-out;
}

.optionItem_q6sB1:hover {
  background-color: var(--f5-background);
}

.breadcrumbs_pFEhF {
  color: var(--_2-color);
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  margin-right: 5px;
}

.breadcrumb_WFTxf {
  display: flex;
  align-items: center;
}

.breadcrumbButton_ek6Bv {
  cursor: pointer;
  color: var(--_22222268-color);
  &:hover {
    color: var(--_2-color);
  }
}
.finalBreadcrumbButton_g81gP {
  color: var(--_22222268-color);
}

.breadcrumbButton_ek6Bv:hover {
  text-decoration: none;
}

.breadcrumbSeparator_EOEmD {
  margin: 0 4px;
}

.noFilesContainer_Nk4MT,
.noFilesContainerMessage_Zk1dN {
  flex: 1 1;
  border: 2px dashed var(--d9d9e3-border);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: var(--_3a-color);
  gap: 10px;
  font-weight: 600;
  cursor: grab;
  h3,
  h4 {
    max-width: 85%;
    font-size: 14px;
    text-align: center;
    font-weight: 600;
    color: var(--_3-color);
  }
  svg {
    max-width: 110px;
    height: 110px;
    width: 70px;
    color: var(--_e6-color) !important;
  }
}
.noFilesContainerMessage_Zk1dN {
  justify-content: center;
  padding-top: 0;
  h4 {
    color: var(--_67-color);
    margin: 0;
  }
}
.bottomMenu_ZwB5c {
  display: flex;
  align-items: center;
  bottom: 10px;
  left: 10px;
  color: var(--_2222226d-color);
  max-height: 25px;
  flex: 1 1;
    overflow-x: auto;
    overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  white-space: nowrap;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  width: 100%;
  span {
    color: var(--_2-color);
  }
  .icon_bmLgM {
    cursor: pointer;
  }
  .houseContainer_WVIuP {
    height: 30px;
    margin-left: 4%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 99px;
    -webkit-border-radius: 99px;
    -moz-border-radius: 99px;
    -ms-border-radius: 99px;
    -o-border-radius: 99px;
    background-color: var(--f5-background);
    cursor: pointer;
    z-index: 1;
    .house_zzpYv {
      height: 15px;
      width: 15px;
      fill: var(--_2-color);
      opacity: 0.5;
    }
    &:hover .house_zzpYv{
      opacity: 1;
      fill: var(--_10a37f-background);
    }
  }
}
.bottomMenu_ZwB5c::-webkit-scrollbar {
  display: none;
}

.offAsideBar_sIOCT {
  z-index: 3;
  left: -100%;
}


.iconImages_ifgmB {
  width: 16px;
  height: 16px;
  &.iconClosed_gX4rn{
    width: 20px;
    height: 20px;
    margin-left: -3px;
    margin-right: -2px;
  }
}

.dotsWrapperHoverHorizontal_CPLl1{
    display: flex;
  align-items: center;
  justify-content: center;
  position: relative; 
}

.dotsWrapperHoverHorizontal_CPLl1:hover{
  .shadowContainerHorizontal_uWdt8 {
    opacity: 1;
  }
}


.shadowContainerHorizontal_uWdt8{
  background-color: var(--_52525261-background);
  transition: all 300ms;
  position: absolute;

  height: 12px;
  opacity: 0;
  pointer-events: none;
    width:24px;
  border-radius: 4px;
}

.loadingImage_x1YUH{
  position: absolute;
  width: 22px;
  height: 22px;
  left: 2px;
  border-radius:100px;
  background:var(--f9-background);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/FileExplorer/FileExplorer.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;;EAEjB,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;EAC9B;IACE,kBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;;EAEf;IACE,4BAA4B;IAC5B,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;EACjC;AACF;AACA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;IACT,YAAY;EACd,0IAA0I;IACxI,iBAAiB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yIAAyI;AAC3I;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,2CAA2C;EAC3C,YAAY;EACZ,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;;;AAIA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ;IACE,WAAW;QACP,YAAY;EAClB;EACA;IACE,aAAa;IACb,sCAAsC;IACtC,yCAAyC;IACzC,YAAY;;EAEd;AACF;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,4FAA4F;EAC5F,SAAO;EACP,qBAAqB;EACrB,wBAAwB;EACxB;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;;;GAIG;;AAEH;EACE,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,YAAY;;AAEd;AACA;EACE,UAAU;EACV,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;;AAGA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B;IACE,sBAAsB;EACxB;AACF;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,SAAO;EACP,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ;;IAEE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,kCAAkC;EACpC;AACF;AACA;EACE,uBAAuB;EACvB,cAAc;EACd;IACE,uBAAuB;IACvB,SAAS;EACX;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;EAChB,SAAO;IACL,gBAAgB;IAChB,kBAAkB;EACpB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;EACX;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,sCAAsC;IACtC,eAAe;IACf,UAAU;IACV;MACE,YAAY;MACZ,WAAW;MACX,qBAAqB;MACrB,YAAY;IACd;IACA;MACE,UAAU;MACV,+BAA+B;IACjC;EACF;AACF;AACA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;IACI,aAAa;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,kBAAkB;;EAElB,YAAY;EACZ,UAAU;EACV,oBAAoB;IAClB,UAAU;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,+BAA+B;AACjC","sourcesContent":[".container {\n  width: 100%;\n  min-width: 200px;\n  width: 200px;\n  max-width: 200px;\n  background: var(--f5-background);\n  height: calc(100vh - 50px);\n  overflow-y: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  max-height: 100vh;\n  width: 80vw;  \n}\n@media (width<= 768px) {\n  .container {\n    overflow-y: inherit;\n    position: absolute;\n    max-width: 100vw;\n    width: 100vw !important;\n  }\n}\n\n.asideBar {\n  height: calc(100vh - 50px);\n  box-sizing: border-box;\n  top: 0;\n  z-index: 4;\n  transition: left 0.3s ease;\n  -webkit-transition: left 0.3s ease;\n  -moz-transition: left 0.3s ease;\n  -ms-transition: left 0.3s ease;\n  -o-transition: left 0.3s ease;\n  position: initial;\n\n  left: 0;  \n}\n.mobileMenu {\n  position: absolute;\n  width: 100vw;\n  z-index: 999999;\n}\n\n.container::-webkit-scrollbar {\n  display: none;\n}\n\n.searchContainer {\n  display: flex;\n  align-items: center;\n  margin-left: 8px;\n}\n\n.filesContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 4px;\n  box-sizing: border-box;\n  height: calc(100vh - 78px);\n  justify-content: space-between;\n  .fileListt {\n    position: relative;\n    display: flex !important;\n    flex-direction: column !important;\n  }\n}\n\n.fileExplorerGetPlusContainer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  height: 15%;\n}\n\n.moreGreen {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  background: var(--white-background);\n  width: 40px;\n  height: 40px;\n  border: 2px solid var(--ca-border);\n  border-radius: 999px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  position: relative;\n}\n.moreGreen svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); \n  width: 20px; \n  height: 20px; \n}\n@media (width <= 768px) {\n  .filesContainer {\n    flex-direction: column-reverse;\n  }\n}\n.searchContainerL {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  cursor: pointer;\n\n  img {\n    transition: filter 0.1s ease;\n    -webkit-transition: filter 0.1s ease;\n    -moz-transition: filter 0.1s ease;\n    -ms-transition: filter 0.1s ease;\n    -o-transition: filter 0.1s ease;\n  }\n}\n.searchContainerIcon {\n  background-color: var(--ececf1-background);\n  padding: 4px;\n  border-radius: 4px;\n  height: 10px;\n  width: 10px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n  cursor: pointer;\n}\n\n\n\n.searchInputWrapper {\n  display: flex;\n  align-items: center;\n  background: var(--white-background);\n  height: 36px;\n  min-height: 36px;\n  border: 1px solid var(--d9d9e3-border);\n  border-radius: 8px;\n  padding: 0px 9px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  width: 100%;\n}\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n.loaderContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n    height: 100%;\n  background: radial-gradient(circle, var(--f5-background) 0%, rgba(245, 245, 245, 0.8) 30%, rgba(245, 245, 245, 0.4) 60%, transparent 100%);\n    position:absolute;\n}\n.bottomLoaderContainer {\n  position:absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle, var(--f5-background) 0%, rgba(245, 245, 245, .8) 80%, rgba(245, 245, 245, 0.4) 90%, transparent 100%);\n}\n.searchIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: var(--_6-color);\n}\n\n.searchInput {\n  flex: 1;\n  padding: 8px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  outline: none;\n}\n\n.searchInput::placeholder {\n  color: var(--_6-color);\n}\n\n.menuIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  color: var(--_6-color);\n  cursor: pointer;\n  padding: 0;\n  background-color: var(--_233f39-background);\n  height: 100%;\n  border-radius: 0 10px 10px 0;\n  -webkit-border-radius: 0 10px 10px 0;\n  -moz-border-radius: 0 10px 10px 0;\n  -ms-border-radius: 0 10px 10px 0;\n  -o-border-radius: 0 10px 10px 0;\n}\n\n.menuIcon:hover {\n  color: var(--_3-color);\n}\n\n\n\n.folderHeader {\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--_3-color);\n}\n\n.folderItem,\n.fileItem {\n  padding: 0px 6px;\n  height: 34px;\n  min-height: 34px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  border-radius: 8px;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.itemInner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  height: 100%;\n  padding: 0px;\n  img {\n    width: 15px;\n        height: 18px;\n  }\n  input{\n    outline: none;\n    border: 1px solid var(--ececf1-border);\n    background-color: var(--white-background);\n    padding: 4px;\n\n  }\n}\n\n.folderItem:hover,\n.fileItem:hover {\n  background-color: var(--f5f5f9-background);\n}\n\n.itemText {\n  font-size: 12px;\n  color: var(--_3-color);\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.fileListt {\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  background: linear-gradient(0deg, var(--e9e9e96d-background) 21%, var(--f5-background) 100%);\n  flex: 2;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.moreButton {\n  position: relative;\n  display: none;\n  border: none;\n  background: none;\n  padding: 4px;\n  cursor: pointer;\n  opacity: 0;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.2s ease-in-out;\n  margin-left: auto;\n  margin-right: 5px;\n}\n\n.fileItem:hover .moreButton {\n  opacity: 0.7;\n  display: flex;\n}\n\n/* .moreButton:hover {\n  opacity: 1 !important;\n  background: var(--ea-background);\n  border-radius: 4px;\n} */\n\n.optionsPopup {\n  position: fixed;\n  background: var(--white-background);\n  border-radius: 8px;\n  box-shadow: 0 2px 10px var(--_0000001a-shadow);\n  width: 115px;\n  z-index: 9999;\n  padding: 4px;\n\n}\n.optionsPopup {\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n  pointer-events: none;\n}\n\n.optionsPopup.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n\n.optionItem {\n  width: 100%;\n  padding: 8px 16px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--_3-color);\n  border-radius: 4px;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.optionItem:hover {\n  background-color: var(--f5-background);\n}\n\n.breadcrumbs {\n  color: var(--_2-color);\n  font-weight: 600;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  cursor: grab;\n  user-select: none;\n  margin-right: 5px;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n}\n\n.breadcrumbButton {\n  cursor: pointer;\n  color: var(--_22222268-color);\n  &:hover {\n    color: var(--_2-color);\n  }\n}\n.finalBreadcrumbButton {\n  color: var(--_22222268-color);\n}\n\n.breadcrumbButton:hover {\n  text-decoration: none;\n}\n\n.breadcrumbSeparator {\n  margin: 0 4px;\n}\n\n.noFilesContainer,\n.noFilesContainerMessage {\n  flex: 1;\n  border: 2px dashed var(--d9d9e3-border);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  color: var(--_3a-color);\n  gap: 10px;\n  font-weight: 600;\n  cursor: grab;\n  h3,\n  h4 {\n    max-width: 85%;\n    font-size: 14px;\n    text-align: center;\n    font-weight: 600;\n    color: var(--_3-color);\n  }\n  svg {\n    max-width: 110px;\n    height: 110px;\n    width: 70px;\n    color: var(--_e6-color) !important;\n  }\n}\n.noFilesContainerMessage {\n  justify-content: center;\n  padding-top: 0;\n  h4 {\n    color: var(--_67-color);\n    margin: 0;\n  }\n}\n.bottomMenu {\n  display: flex;\n  align-items: center;\n  bottom: 10px;\n  left: 10px;\n  color: var(--_2222226d-color);\n  max-height: 25px;\n  flex: 1;\n    overflow-x: auto;\n    overflow-y: hidden;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  white-space: nowrap;\n  cursor: grab;\n  user-select: none;\n  width: 100%;\n  span {\n    color: var(--_2-color);\n  }\n  .icon {\n    cursor: pointer;\n  }\n  .houseContainer {\n    height: 30px;\n    margin-left: 4%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 99px;\n    -webkit-border-radius: 99px;\n    -moz-border-radius: 99px;\n    -ms-border-radius: 99px;\n    -o-border-radius: 99px;\n    background-color: var(--f5-background);\n    cursor: pointer;\n    z-index: 1;\n    .house {\n      height: 15px;\n      width: 15px;\n      fill: var(--_2-color);\n      opacity: 0.5;\n    }\n    &:hover .house{\n      opacity: 1;\n      fill: var(--_10a37f-background);\n    }\n  }\n}\n.bottomMenu::-webkit-scrollbar {\n  display: none;\n}\n\n.offAsideBar {\n  z-index: 3;\n  left: -100%;\n}\n\n\n.iconImages {\n  width: 16px;\n  height: 16px;\n  &.iconClosed{\n    width: 20px;\n    height: 20px;\n    margin-left: -3px;\n    margin-right: -2px;\n  }\n}\n\n.dotsWrapperHoverHorizontal{\n    display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative; \n}\n\n.dotsWrapperHoverHorizontal:hover{\n  .shadowContainerHorizontal {\n    opacity: 1;\n  }\n}\n\n\n.shadowContainerHorizontal{\n  background-color: var(--_52525261-background);\n  transition: all 300ms;\n  position: absolute;\n\n  height: 12px;\n  opacity: 0;\n  pointer-events: none;\n    width:24px;\n  border-radius: 4px;\n}\n\n.loadingImage{\n  position: absolute;\n  width: 22px;\n  height: 22px;\n  left: 2px;\n  border-radius:100px;\n  background:var(--f9-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_WAkLX`,
	"asideBar": `asideBar_Fdam_`,
	"mobileMenu": `mobileMenu_DmXUA`,
	"searchContainer": `searchContainer_hoqds`,
	"filesContainer": `filesContainer_Si__B`,
	"fileListt": `fileListt_b3FJ_`,
	"fileExplorerGetPlusContainer": `fileExplorerGetPlusContainer_NqGOc`,
	"moreGreen": `moreGreen__xJWV`,
	"searchContainerL": `searchContainerL_hvS1d`,
	"searchContainerIcon": `searchContainerIcon_e3t9V`,
	"searchInputWrapper": `searchInputWrapper_sqz6O`,
	"searchIconsWrappers": `searchIconsWrappers_VAOS4`,
	"loaderContainer": `loaderContainer_NIcBB`,
	"bottomLoaderContainer": `bottomLoaderContainer_QFHHr`,
	"searchIcon": `searchIcon_CtmiT`,
	"searchInput": `searchInput_zkxPa`,
	"menuIcon": `menuIcon_HVJJj`,
	"folderHeader": `folderHeader_K3DzI`,
	"folderItem": `folderItem_iXVDX`,
	"fileItem": `fileItem_mSXrc`,
	"itemInner": `itemInner_alHLw`,
	"itemText": `itemText_ClVHr`,
	"moreButton": `moreButton_q9u8C`,
	"optionsPopup": `optionsPopup_NRs9Y`,
	"visible": `visible__GGP7`,
	"optionItem": `optionItem_q6sB1`,
	"breadcrumbs": `breadcrumbs_pFEhF`,
	"breadcrumb": `breadcrumb_WFTxf`,
	"breadcrumbButton": `breadcrumbButton_ek6Bv`,
	"finalBreadcrumbButton": `finalBreadcrumbButton_g81gP`,
	"breadcrumbSeparator": `breadcrumbSeparator_EOEmD`,
	"noFilesContainer": `noFilesContainer_Nk4MT`,
	"noFilesContainerMessage": `noFilesContainerMessage_Zk1dN`,
	"bottomMenu": `bottomMenu_ZwB5c`,
	"icon": `icon_bmLgM`,
	"houseContainer": `houseContainer_WVIuP`,
	"house": `house_zzpYv`,
	"offAsideBar": `offAsideBar_sIOCT`,
	"iconImages": `iconImages_ifgmB`,
	"iconClosed": `iconClosed_gX4rn`,
	"dotsWrapperHoverHorizontal": `dotsWrapperHoverHorizontal_CPLl1`,
	"shadowContainerHorizontal": `shadowContainerHorizontal_uWdt8`,
	"loadingImage": `loadingImage_x1YUH`
};
export default ___CSS_LOADER_EXPORT___;
